import React from 'react';

const PageHeader = ({ 
  title, 
  subtitle, 
  backgroundImage = 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072',
  overlayOpacity = 0.7 
}) => {
  return (
    <div className="relative h-[300px] md:h-[400px] w-full overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      
      {/* Gradient Overlay */}
      <div 
        className="absolute inset-0 bg-gradient-to-r from-[#320547] to-[#95228A]"
        style={{ opacity: overlayOpacity }}
      />
      
      {/* Content */}
      <div className="relative h-full flex items-center justify-center text-center px-4">
        <div className="max-w-4xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 drop-shadow-lg">
            {title}
          </h1>
          {subtitle && (
            <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto font-medium">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
